import React from "react";
import Spinner from '../Spinner';

interface ButtonProps {
  text?: string;
  icon?: React.ReactNode;
  type?: "button" | "submit"
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  ariaLabel?: string;
  onClick?: (_: any) => void;
}

const Button: React.FC<ButtonProps> = ({
  text, icon, type = "button", className, disabled, loading, ariaLabel, onClick,
}) => {
  return (
    <button
      className={className}
      disabled={disabled || loading}
      type={type}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {loading ? (
        <Spinner />
      ) : (
        <>
          {icon && icon}
          {text && text}
        </>
      )}
    </button>
  );
};

export default Button;